import { createTheme } from '@mui/material';
import { type Theme as MuiTheme } from '@mui/material/styles';

import { FontDefinitions } from '@/assets/fonts.ts';
import { lightPalette } from '@/theme/LightTheme.ts';
import { buttonComponentOverrides } from '@/theme/components/ButtonOverrides.ts';
import { cardComponentOverrides } from '@/theme/components/CardOverrides.ts';
import { chipComponentOverrides } from '@/theme/components/ChipOverrides.ts';
import { paperComponentOverrides } from '@/theme/components/PaperOverrides.ts';
import { popupComponentOverrides } from '@/theme/components/PopupOverrides.ts';
import { skeletonComponentOverrides } from '@/theme/components/SkeletonOverrides.ts';
import '@/theme/components/SwitchOverrides.ts';
import { tabsComponentOverrides } from '@/theme/components/TabsOverrides.ts';
import {
  TypographyComponentOverrides,
  defaultTypographyOptions,
} from '@/theme/components/TypographyOverrides.ts';

type CreateThemeDefinitionType = Parameters<typeof createTheme>[0];

export const createThemeDefinition: CreateThemeDefinitionType = {
  cssVariables: true,
  colorSchemes: {
    light: {
      palette: lightPalette,
    },
  },

  defaultColorScheme: 'light',
  spacing: (factor: number) => `${0.125 * factor}rem`,

  // Apply font typeset from Figma
  typography: defaultTypographyOptions,
  components: {
    MuiCssBaseline: {
      styleOverrides: `
    ${FontDefinitions.NunitoSans}
    `,
    },
    MuiButton: buttonComponentOverrides,
    ...cardComponentOverrides,
    MuiChip: chipComponentOverrides,
    MuiPaper: paperComponentOverrides,
    ...popupComponentOverrides,
    MuiSkeleton: skeletonComponentOverrides,
    ...tabsComponentOverrides,
    MuiTypography: TypographyComponentOverrides,
  },
};

export type Theme = MuiTheme;

export const appTheme = createTheme(createThemeDefinition);
